import { CreateProductResponse, PostApiProductsCreateProductBody } from '../../shared/api/generated'
import { createInstance } from '../../shared/api/serverConstants'

// ASP.NET binds collections of objects using indexed property names.
// Keep this outside generated.ts so API regeneration cannot discard it.
export function createProductFormData(data: PostApiProductsCreateProductBody): FormData {
  const formData = new FormData()
  Object.entries(data).forEach(([key, value]) => {
    if (value === undefined || value === null) return
    if (Array.isArray(value)) {
      value.forEach((item, index) => {
        if (item instanceof Blob) {
          formData.append(key, item)
        } else if (typeof item === 'object' && item !== null) {
          Object.entries(item).forEach(([property, propertyValue]) => {
            if (propertyValue !== undefined && propertyValue !== null)
              formData.append(`${key}[${index}].${property}`, String(propertyValue))
          })
        } else {
          formData.append(key, String(item))
        }
      })
    } else {
      formData.append(key, String(value))
    }
  })
  return formData
}

export function createProduct(data: PostApiProductsCreateProductBody) {
  return createInstance<CreateProductResponse>({
    url: '/api/Products/createProduct',
    method: 'POST',
    data: createProductFormData(data),
  })
}
